module.exports = __webpack_public_path__ + "img/visa.933c31d9.png";